import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faArrowLeft, faHome, faDoorClosed } from '@fortawesome/free-solid-svg-icons';

const DoorSkeletonLoader = () => {
  return (
    <div className="flex flex-col h-screen bg-gray-50">
    {/* Header Skeleton */}
    <div className="bg-white sticky top-0 z-50 border-b border-gray-200">
      <div className="h-1 bg-gradient-to-r"></div>
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          {/* Back Button - Replace icon with animated placeholder */}
          <div className="flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-red-50 to-white rounded-xl">
              {/* Replace FontAwesomeIcon with animated div */}
              <div className="w-5 h-5 bg-gray-200 animate-pulse rounded-md"></div>
            </div>
          </div>

            {/* Project Name and Category Container */}
            <div className="flex-1 flex flex-col items-center">
              <div className="h-6 w-48 bg-gray-200 animate-pulse rounded-md mb-0.5"></div>
              <div className="flex items-center gap-1.5">
                <div className="w-1 h-1"></div>
                <div className="h-4 w-12 bg-gray-200 animate-pulse rounded-md"></div>
                <div className="w-1 h-1"></div>
              </div>
            </div>

            {/* Home Button */}
            <div className="flex-shrink-0">
              <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-red-50 to-white rounded-xl">
                {/* Replace FontAwesomeIcon with animated div */}
                <div className="w-5 h-5 bg-gray-200 animate-pulse rounded-md"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <main className="flex-1 overflow-y-auto mt-1 mb-4 pb-3">
        <div className="p-4 pb-2 max-w-4xl mx-auto">
          {/* Pre Eng Doors Section Skeleton */}
          <section className="mb-8">
            <div className="sticky top-0 z-40 bg-gray-50">
              <div className="bg-white rounded-xl shadow-sm mb-3">
                <div className="px-1 py-4">
                  <div className="flex items-start justify-between">
                    <div className="flex items-start">
                      {/* Replace door icon with animated placeholder */}
                      <div className="w-10 h-10 bg-gradient-to-br ml-1 rounded-xl flex items-center justify-center shadow-sm flex-shrink-0">
                        {/* Replace FontAwesomeIcon with animated div */}
                        <div className="w-6 h-6 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                      <div className="ml-4">
                        <div className="h-5 w-32 bg-gray-200 animate-pulse rounded-md mb-1"></div>
                        <div className="h-3 w-40 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center gap-2 pl-1 border-l border-gray-100">
                      <div className="h-4 w-24 bg-gray-200 animate-pulse rounded-md"></div>
                      <div className="w-12 h-5 bg-gray-200 animate-pulse rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              {/* Door Category Cards Skeleton - Pre Eng */}
              {[1, 2].map((item) => (
                <div key={`pre-eng-${item}`} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                  <div className="p-2 border-b border-gray-100">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="h-5 w-5 bg-gray-200 animate-pulse rounded-full"></div>
                        <div className="h-5 w-32 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="h-5 w-20 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                    </div>
                  </div>

                  <div className="p-2">
                    <div className="flex justify-between items-center mb-2">
                      <div className="flex items-center gap-3">
                        <div className="h-8 w-8 bg-gray-200 animate-pulse rounded-full"></div>
                        <div className="h-5 w-40 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                      <div className="h-6 w-20 bg-gray-200 animate-pulse rounded-full"></div>
                    </div>

                    <div className="mt-1 bg-gray-50 rounded-lg p-3">
                      <div className="grid grid-cols-3 gap-4">
                        <div className="flex flex-col text-center">
                          <div className="h-3 w-16 bg-gray-200 animate-pulse rounded-md mx-auto mb-2"></div>
                          <div className="h-4 w-20 bg-gray-200 animate-pulse rounded-md mx-auto"></div>
                        </div>
                        <div className="flex flex-col text-center">
                          <div className="h-3 w-16 bg-gray-200 animate-pulse rounded-md mx-auto mb-2"></div>
                          <div className="h-4 w-24 bg-gray-200 animate-pulse rounded-md mx-auto"></div>
                        </div>
                        <div className="flex flex-col text-right">
                          <div className="h-3 w-12 bg-gray-200 animate-pulse rounded-md ml-auto mb-2"></div>
                          <div className="h-5 w-20 bg-gray-200 animate-pulse rounded-md ml-auto"></div>
                        </div>
                      </div>
                    </div>

                    {/* Addons Skeleton */}
                    <div className="mt-3 border-t border-gray-100">
                      <div className="flex items-center justify-between w-full py-3">
                        <div className="flex items-center">
                          <div className="w-6 h-6 bg-gray-200 animate-pulse rounded-full"></div>
                          <div className="ml-2 h-5 w-28 bg-gray-200 animate-pulse rounded-md"></div>
                        </div>
                        <div className="h-4 w-4 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>
                    </div>

                    {/* Hardware Skeleton */}
                    <div className="mt-3 border-t border-gray-100 pt-2">
                      <div className="flex items-center justify-between w-full py-3">
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-gray-200 animate-pulse rounded-full"></div>
                          <div className="ml-3">
                            <div className="h-5 w-28 bg-gray-200 animate-pulse rounded-md mb-1"></div>
                            <div className="h-3 w-40 bg-gray-200 animate-pulse rounded-md"></div>
                          </div>
                        </div>
                        <div className="h-6 w-6 bg-gray-200 animate-pulse rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Only Doors Section Skeleton */}
          <section className="mb-8">
  <div className="sticky top-0 z-40 bg-gray-50">
    <div className="bg-white rounded-xl shadow-sm mb-3">
      {/* Header content */}
    </div>
  </div>
  
  <div className="space-y-3">
    {/* Update the number of skeleton cards to match your typical data */}
    {[1, 2, 3].map((item) => (
      <div key={`pre-eng-${item}`} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
        {/* Card content */}
      </div>
    ))}
  </div>
</section>
          {/* Green Info Box Skeleton */}
          {/* Green Info Box Skeleton */}
          <div className="flex items-center gap-2 px-4 py-2 bg-green-50 rounded-lg">
            <div className="w-5 h-5 bg-gray-200 animate-pulse rounded-full"></div>
            <div className="h-4 w-64 bg-gray-200 animate-pulse rounded-md"></div>
          </div>

          {/* Packages Skeleton */}
          <div className="p-5 mt-6 mb-16 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-red-100 p-2 rounded-lg">
                <div className="h-5 w-5 bg-gray-200 animate-pulse rounded-md"></div>
              </div>
              <div className="h-5 w-40 bg-gray-200 animate-pulse rounded-md"></div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {[1, 2].map((item) => (
                <div key={`package-${item}`} className="group relative overflow-hidden flex flex-col p-4 bg-white border border-gray-200 rounded-xl">
                  <div className="h-6 w-32 bg-gray-200 animate-pulse rounded-md mb-3"></div>
                  <div className="flex items-center justify-between">
                    <div className="h-5 w-24 bg-gray-200 animate-pulse rounded-md"></div>
                    <div className="h-5 w-5 bg-gray-200 animate-pulse rounded-md"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Bottom Floating Button Skeleton */}
      <div className="fixed bottom-0 w-full bg-white border-t border-gray-200 shadow-xl z-10">
        <div className="px-4 py-3">
          <div className="flex items-center justify-between w-full gap-3">
            <div className="w-[30%] h-[48px] bg-gray-200 animate-pulse rounded-lg"></div>
            <div className="w-[70%] h-[48px] bg-gray-200 animate-pulse rounded-lg"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoorSkeletonLoader;
